/** Intake invalidations join server-resolved project/global rooms. */

import { WebSocketClient } from '../client'
import { SubscriptionRegistry } from '../subscriptions'
import type { IntakeEventPayload } from '@/types/intake'

export const INTAKE_EVENTS = [
  'intake_item_created',
  'intake_item_updated',
  'intake_item_claimed',
  'intake_item_converted',
  'intake_item_dismissed',
  'intake_item_duplicate_marked',
  'intake_item_reopened',
  'intake_item_redacted',
  'intake_item_deleted',
  'intake_item_assigned',
] as const

export class IntakeLiveApi {
  private readonly changes: SubscriptionRegistry<null, IntakeEventPayload>

  constructor(private readonly client: WebSocketClient) {
    this.changes = new SubscriptionRegistry({
      join: () => this.client.emitWhenConnected('subscribe_intake', {}),
      leave: () => this.client.emitWhenConnected('unsubscribe_intake', {}),
    })
  }

  subscribe(callback: (payload: IntakeEventPayload) => void): () => void {
    this.attachHandlers()
    return this.changes.subscribe(null, callback)
  }

  private attachHandlers(): void {
    if (!this.client.hasSocket()) return
    for (const event of INTAKE_EVENTS) {
      this.client.attachOnce(event, (raw) =>
        this.changes.dispatch(null, raw as IntakeEventPayload)
      )
    }
  }

  replay(): void {
    this.attachHandlers()
    this.changes.replay()
  }

  clear(): void {
    this.changes.clear()
  }
}
